import { useRef, useState, useEffect, useContext, useMemo, memo } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { DashboardContext } from "states/DashboardContext";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { BsSearch } from "react-icons/bs";
import { CircularProgress, ListItem } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import CensusService from "../../../_services/Census/CensusService";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CensusLoadingCmp from "./CensusLoadingCmp";
import { TextField, InputAdornment, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FormatSizeIcon from "@mui/icons-material/FormatSize"; // Case Sensitive
import ShortTextIcon from "@mui/icons-material/ShortText"; // Exact Match
import CodeIcon from "@mui/icons-material/Code"; // Regex
import { FixedSizeList as VirtualList } from "react-window";
import FormControlLabel from "@mui/material/FormControlLabel";

const censusService = CensusService();

const CensusIndicatorDropDown = () => {
  const {
    dataSourceState,
    censusMapDataState,
    filterDataState,
    censusIndicatorNameState,
    censusSubGroupNameState,
    censusIsDefaultDataState,
    languageState,
    censusSelectedIndicatorState,
    loadingState,
    sectorState,
    subsectorState,
    indicatorState,
    subgroupState,
  } = useContext(DashboardContext);

  //   const [dataSource, setDatasource] = dataSourceState;
  const [censusMapData, setCensusMapData] = censusMapDataState;
  const [censusIndicatorName, setCensusIndicatorName] =
    censusIndicatorNameState;
  const [censusSubGroupName, setCensusSubGroupName] = censusSubGroupNameState;
  const [censusIsDefaultData, setCensusIsDefaultData] =
    censusIsDefaultDataState;
  const [filterData, setFilterData] = filterDataState;
  const [language] = languageState;
  const [censusSelectedIndicator, setCensusSelectedIndicator] =
    censusSelectedIndicatorState;
  const [loading, setLoading] = loadingState;
  const [sector, setSector] = sectorState;
  const [subsector, setSubsector] = subsectorState;
  const [indicator, setIndicator] = indicatorState;
  const [subgroup, setSubgroup] = subgroupState;

  // component state
  const [expandedSectors, setExpandedSectors] = useState(new Set());
  const [selectedSectorShortName, setSelectedSectorShortName] = useState();
  const [selectedSubSectorKey, setSelectedSubSectorKey] = useState();
  const [selectedIndicatorKey, setSelectedIndicatorKey] = useState();
  const [selectdIndicatorShortName, setSelectedIndicatorShortName] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [censusYears, setCensusYears] = useState([]);
  const [anchorEls, setAnchorEls] = React.useState({
    indicatorPopover: null,
    areaPopover: null,
    yearPopover: null,
  });

  const [searchOptions, setSearchOptions] = useState({
    caseSensitive: false,
    exactMatch: false,
    regex: false,
  });

  const toggleSearchOption = (option) => {
    setSearchOptions((prev) => ({
      ...prev,
      [option]: !prev[option], // Toggle the selected option
    }));
  };

  //Implementing the searching of categories
  const [categorySearchText, setCategorySearchText] = useState({
    sector: {},
    subsector: {},
    indicator: {},
    subgroup: {},
  });

  const handleSearchChange = (category, key, event) => {
    setCategorySearchText((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: event.target.value,
      },
    }));
  };

  const handleClick = (event, popoverName) => {
    setAnchorEls({ ...anchorEls, [popoverName]: event.currentTarget });
  };

  const handleClose = (popoverName) => {
    setAnchorEls({ ...anchorEls, [popoverName]: null });
  };

  // function to set indicators
  function setIndicators(
    indicatorkey,
    indicatorshortname,
    subgroupkey,
    subgroup_name
  ) {
    setCensusSelectedIndicator((state) => {
      const existingIndicatorIndex = state.findIndex(
        (item) => item.indicatorkey === indicatorkey
      );

      if (existingIndicatorIndex !== -1) {
        // If the indicator exists, remove the existing subgroupkey
        const updatedIndicators = [...state];
        const existingSubgroupIndex =
          updatedIndicators[existingIndicatorIndex].subgroupkey.indexOf(
            subgroupkey
          );

        if (existingSubgroupIndex !== -1) {
          updatedIndicators[existingIndicatorIndex].subgroupkey.splice(
            existingSubgroupIndex,
            1
          );
        }

        if (existingSubgroupIndex === -1) {
          // If subgroupkey doesn't exist, add it to the list
          updatedIndicators[existingIndicatorIndex].subgroupkey.push(
            subgroupkey
          );
        }

        // If subgroupkey is empty after removal, remove the whole indicator
        if (
          updatedIndicators[existingIndicatorIndex].subgroupkey.length === 0
        ) {
          updatedIndicators.splice(existingIndicatorIndex, 1);
        }

        // if the selected indicator list is null, reset the map data
        setCensusMapData([]);

        return updatedIndicators;
      } else {
        // If the indicator does not exist, add a new one
        return [
          ...state,
          {
            sectorshortname: selectedSectorShortName,
            subsectorkey: selectedSubSectorKey,
            indicatorkey: indicatorkey,
            indicator_short_name: indicatorshortname,
            subgroupkey: [subgroupkey],
          },
        ];
      }
    });
  }

  const toggleSet = (set, key) => {
    const newSet = new Set(set);
    if (newSet.has(key)) {
      newSet.delete(key);
    } else {
      newSet.add(key);
    }
    return newSet;
  };

  const toggleSector = (sectorKey) =>
    setExpandedSectors((prev) => toggleSet(prev, sectorKey));
  const toggleSubsector = (subsectorKey) =>
    setExpandedSubsectors((prev) => toggleSet(prev, subsectorKey));
  const toggleIndicator = (indicatorKey) =>
    setExpandedIndicators((prev) => toggleSet(prev, indicatorKey));

  // Create a memoized set of selected (indicatorKey, subgroupKey) pairs
  const selectedSubgroupsSet = useMemo(() => {
    const set = new Set();
    for (const item of censusSelectedIndicator) {
      if (item.subgroupkey) {
        for (const subKey of item.subgroupkey) {
          set.add(`${item.indicatorkey}-${subKey}`);
        }
      }
    }
    return set;
  }, [censusSelectedIndicator]);

  const isSelected = (indicatorKey, subgroupKey) => {
    if (subgroupKey !== undefined) {
      return selectedSubgroupsSet.has(`${indicatorKey}-${subgroupKey}`);
    }
    return false; // Or handle if needed
  };

  const fetchSector = async () => {
    try {
      const response = await censusService.getSectors();
      setSector(response);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSubSector = async () => {
    try {
      const response = await censusService.getSubSectors();
      setSubsector(response);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchIndicator = async () => {
    try {
      const response = await censusService.getIndicators();
      setIndicator(response);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSubGroups = async () => {
    try {
      setIsLoading(true);
      const response = await censusService.getSubGroups(selectedIndicatorKey);
      setSubgroup(response);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSector();
    fetchSubSector();
    fetchIndicator();
  }, []);

  useEffect(() => {
    if (selectedIndicatorKey) {
      fetchSubGroups();
    }
  }, [selectedIndicatorKey]);

  const SubgroupItem = React.memo(
    ({
      subg,
      selectedIndicatorKey,
      isSelected,
      setIndicators,
      selectdIndicatorShortName,
    }) => (
      <ListItem
        key={subg.subgroupkey}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <ListItemButton sx={{ pl: 2 }}>
          <Checkbox
            checked={isSelected(selectedIndicatorKey, subg.subgroupkey)}
            onChange={() =>
              setIndicators(
                selectedIndicatorKey,
                selectdIndicatorShortName,
                subg.subgroupkey,
                subg.subgroup_name
              )
            }
          />
          <ListItemText primary={subg.subgroup_name} />
        </ListItemButton>
      </ListItem>
    )
  );

  const visibleSubgroups = useMemo(() => {
    let filtered = subgroup.filter(
      (sub) => sub.indicatorkey === selectedIndicatorKey
    );

    const searchText = categorySearchText.subgroup[selectedIndicatorKey] || "";

    if (searchText) {
      const caseSensitive = searchOptions.caseSensitive;
      const exactMatch = searchOptions.exactMatch;

      filtered = filtered.filter((sub) => {
        const rawName = sub.subgroup_name;

        const name = caseSensitive ? rawName : rawName.toLowerCase();
        const query = caseSensitive ? searchText : searchText.toLowerCase();

        if (exactMatch) {
          return name === query;
        }

        return name.includes(query);
      });
    }

    return filtered;
  }, [subgroup, selectedIndicatorKey, categorySearchText, searchOptions]);

  const areAllSubgroupsSelected = visibleSubgroups.every((subg) =>
    isSelected(selectedIndicatorKey, subg.subgroupkey)
  );

  const someSubgroupsSelected = visibleSubgroups.some((subg) =>
    isSelected(selectedIndicatorKey, subg.subgroupkey)
  );

  // Handle Select All
  const handleSelectAllSubgroups = (event) => {
    const checked = event.target.checked;

    visibleSubgroups.forEach((subg) => {
      setIndicators(
        selectedIndicatorKey,
        selectdIndicatorShortName,
        subg.subgroupkey,
        subg.subgroup_name,
        checked // You may need to modify setIndicators to accept the checked state
      );
    });
  };

  return (
    <>
      <Button
        onClick={(e) => handleClick(e, "indicatorPopover")}
        sx={{
          backgroundColor: "#fff",
          color: "black",
          paddingTop: 0,
          paddingBottom: 0,
          textTransform: "none",
          border: "1px solid #ddd",
          boxShadow: "none",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
        variant="contained"
      >
        <AddIcon fontSize="small" className="text-sm" />
        Select Indicators
      </Button>

      <Popover
        open={Boolean(anchorEls.indicatorPopover)}
        onClose={() => handleClose("indicatorPopover")}
        anchorEl={anchorEls.indicatorPopover}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        {loading ? (
          <div className="p-6">
            <CircularProgress size={"1.25rem"} className="h-4 w-4" />
          </div>
        ) : (
          <>
            <div className="flex justify-between p-0 bg-gray-100">
              <Typography sx={{ p: 1 }}>Select Indicators</Typography>
              <button
                onClick={() => handleClose("indicatorPopover")}
                className="px-6 border border-blue-400 mr-5 rounded-12"
              >
                Save
              </button>
            </div>
            {/* Three-column layout using Grid */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)", // 3 equal columns
                gap: 2,
                width: "1200px", // Adjust width based on content
                padding: "10px",
                height: "400px",
              }}
            >
              {/* First Column - Original Sectors */}
              <Box
                sx={{
                  maxHeight: "400px", // Fixed height
                  overflowY: "auto", // Scrollable if content overflows
                  paddingRight: "1px", // Space for scrollbar
                  borderRight: "1px solid #ccc",
                }}
              >
                <Typography sx={{ p: 2, fontWeight: "bold" }}>
                  {" "}
                  Sectors
                </Typography>
                {sector
                  .sort((a, b) => a.sector_name.localeCompare(b.sector_name))
                  .map((sec) => (
                    <ListItem
                      key={sec.sectorkey}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <ListItemButton
                        sx={{
                          pl: 2,
                          backgroundColor: censusSelectedIndicator.some(
                            (sector) =>
                              sector.sectorshortname === sec.sector_short_name
                          )
                            ? "#eaecee"
                            : "",
                        }}
                        onClick={() => {
                          setSelectedSectorShortName(sec.sector_short_name);
                          toggleSector(sec.sectorkey);
                        }}
                        dense={true}
                      >
                        {expandedSectors.has(sec.sectorkey) ? (
                          <RemoveIcon
                            className="border mr-1"
                            fontSize="small"
                          />
                        ) : (
                          <AddIcon className="border mr-1" fontSize="small" />
                        )}
                        <ListItemText primary={sec.sector_name} />
                      </ListItemButton>

                      <Collapse
                        in={expandedSectors.has(sec.sectorkey)}
                        timeout="auto"
                        unmountOnExit
                      >
                        {subsector.filter(
                          (sub) =>
                            sub.sector_short_name === sec.sector_short_name
                        ).length > 4 && (
                          <div className="p-2">
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              placeholder="Search within this sector"
                              value={
                                categorySearchText.sector[sec.sectorkey] || ""
                              }
                              onChange={(e) =>
                                handleSearchChange("sector", sec.sectorkey, e)
                              }
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton>
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}
                        <List
                          component="div"
                          sx={{ marginLeft: "30px", padding: 0 }}
                        >
                          {subsector
                            .filter(
                              (subSec) =>
                                subSec.sector_short_name ===
                                sec.sector_short_name
                            )
                            .filter((subsec) =>
                              categorySearchText.sector[sec.sectorkey]
                                ? subsec.subsector_name
                                    .toLowerCase()
                                    .includes(
                                      categorySearchText.sector[sec.sectorkey]
                                    )
                                : true
                            )
                            .map((subSec) => (
                              <ListItem key={subSec.subsectorkey}>
                                <ListItemButton
                                  sx={{
                                    backgroundColor:
                                      censusSelectedIndicator.some(
                                        (subsector) =>
                                          subsector.subsectorkey ===
                                          subSec.subsectorkey
                                      )
                                        ? "#eaecee"
                                        : "",
                                  }}
                                  onClick={() => {
                                    setSelectedSubSectorKey(
                                      subSec?.subsectorkey
                                    );
                                  }}
                                >
                                  <ListItemText
                                    primary={subSec.subsector_name}
                                  />
                                </ListItemButton>
                              </ListItem>
                            ))}
                        </List>
                      </Collapse>
                    </ListItem>
                  ))}
              </Box>

              {/* Second Column - Other Related Data */}
              <Box
                sx={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  paddingRight: "1px",
                  borderRight: "1px solid #ccc",
                }}
              >
                <Typography sx={{ p: 2, fontWeight: "bold" }}>
                  {" "}
                  Indicators
                </Typography>
                {indicator.filter(
                  (ind) => ind.subsectorkey === selectedSubSectorKey
                ).length > 4 && (
                  <div className="p-2">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      placeholder="Search within this indicators"
                      value={
                        categorySearchText.indicator[selectedSubSectorKey] || ""
                      }
                      onChange={(e) =>
                        handleSearchChange("indicator", selectedSubSectorKey, e)
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                )}
                {selectedSubSectorKey && (
                  <List>
                    {indicator
                      .filter(
                        (ind) => ind.subsectorkey === selectedSubSectorKey
                      )
                      .filter((ind) =>
                        categorySearchText.indicator[selectedSubSectorKey]
                          ? ind.indicator_name
                              .toLowerCase()
                              .includes(
                                categorySearchText.indicator[
                                  selectedSubSectorKey
                                ]
                              )
                          : true
                      )
                      .map((ind) => (
                        <ListItem
                          key={ind.indicatorkey}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                          }}
                        >
                          <ListItemButton
                            sx={{
                              pl: 2,
                              backgroundColor: censusSelectedIndicator.some(
                                (selectedInd) =>
                                  selectedInd.indicatorkey === ind.indicatorkey
                              )
                                ? "#eaecee"
                                : "",
                            }}
                            onClick={() => {
                              setSelectedIndicatorKey(ind.indicatorkey);
                              setSelectedIndicatorShortName(
                                ind.indicator_short_name
                              );
                            }}
                            dense={true}
                          >
                            <ListItemText primary={ind.indicator_name} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                  </List>
                )}
              </Box>

              {/* Third Column - More Data */}
              <Box
                sx={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  paddingRight: "1px",
                }}
              >
                <Typography sx={{ p: 2, fontWeight: "bold" }}>
                  {" "}
                  Subgroups
                </Typography>

                {selectedIndicatorKey &&
                  (isLoading ? (
                    <CircularProgress />
                  ) : (
                    <>
                      {subgroup.filter(
                        (sub) => sub.indicatorkey === selectedIndicatorKey
                      ).length > 4 && (
                        <div className="p-2">
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            placeholder="Search within this subgroups"
                            value={
                              categorySearchText.subgroup[
                                selectedIndicatorKey
                              ] || ""
                            }
                            onChange={(e) =>
                              handleSearchChange(
                                "subgroup",
                                selectedIndicatorKey,
                                e
                              )
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <IconButton>
                                    <SearchIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <InputAdornment position="end">
                                  {/* Case Sensitive */}
                                  <Tooltip title="Case Sensitive">
                                    <IconButton
                                      onClick={() =>
                                        toggleSearchOption("caseSensitive")
                                      }
                                      color={
                                        searchOptions.caseSensitive
                                          ? "primary"
                                          : "default"
                                      }
                                    >
                                      <FormatSizeIcon />
                                    </IconButton>
                                  </Tooltip>

                                  {/* Exact Match */}
                                  <Tooltip title="Exact Match">
                                    <IconButton
                                      onClick={() =>
                                        toggleSearchOption("exactMatch")
                                      }
                                      color={
                                        searchOptions.exactMatch
                                          ? "primary"
                                          : "default"
                                      }
                                    >
                                      <ShortTextIcon />
                                    </IconButton>
                                  </Tooltip>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      )}
                      <FormControlLabel
                        sx={{ fontWeight: "bold", marginLeft: "15px" }}
                        control={
                          <Checkbox
                            checked={areAllSubgroupsSelected}
                            indeterminate={
                              someSubgroupsSelected && !areAllSubgroupsSelected
                            }
                            onChange={handleSelectAllSubgroups}
                          />
                        }
                        label={
                          <span style={{ fontWeight: "bold" }}>
                            Select All Subgroups
                          </span>
                        }
                      />
                      <VirtualList
                        height={400} // Box height
                        width="100%"
                        itemSize={50} // Approx height of each SubgroupItem (adjust as needed)
                        itemCount={visibleSubgroups.length}
                        itemData={visibleSubgroups}
                      >
                        {({ index, style, data }) => {
                          const subg = data[index];
                          return (
                            <div style={style}>
                              <SubgroupItem
                                key={subg.subgroupkey}
                                subg={subg}
                                selectedIndicatorKey={selectedIndicatorKey}
                                isSelected={isSelected}
                                setIndicators={setIndicators}
                                selectdIndicatorShortName={
                                  selectdIndicatorShortName
                                }
                              />
                            </div>
                          );
                        }}
                      </VirtualList>
                    </>
                  ))}
              </Box>
            </Box>
          </>
        )}
      </Popover>
    </>
  );
};

export default CensusIndicatorDropDown;
